module.exports = __webpack_public_path__ + "assets/img/workdrive-new.ae68b1ff.svg";